import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { FeatureListProvider } from './FeatureList.Context/FeatureList.Context.es.js';
import { FeatureListIcon } from './FeatureList.Icon/FeatureList.Icon.es.js';
import { FeatureListItem } from './FeatureList.Item/FeatureList.Item.es.js';

const FeatureList = ({ direction = 'vertical', size = 'base', variant = 'primary', className, children })=>{
    return jsx(FeatureListProvider, {
        direction: direction,
        size: size,
        variant: variant,
        children: jsx("dl", {
            className: classNames('cb-feature-list', direction, className),
            "data-testid": "feature-list",
            children: children
        })
    });
};
FeatureList.displayName = 'FeatureList';
FeatureList.Item = FeatureListItem;
FeatureList.Icon = FeatureListIcon;

export { FeatureList, FeatureList as default };
//# sourceMappingURL=FeatureList.es.js.map
